import { render, staticRenderFns } from "./OrderClientCard.vue?vue&type=template&id=d171068a"
import script from "./OrderClientCard.vue?vue&type=script&lang=js"
export * from "./OrderClientCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports